<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && [1, 5, 7].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :allBtnWidth="200" :page="page" :limit="limit"
      :total="total" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="gettrip" slot-scope="params">
        <!-- <el-button class="positionbtn" type="primary" @click="showTrip(params.params)" size="mini">{{
          params.params.gettrip }}</el-button> -->
        <div class="lcbtn" @click="showTrip(params.params)">{{ params.params.gettrip }}</div>
      </template>
      <template slot="btn1" slot-scope="params">
        <el-button class="positionbtn" type="primary" @click="showPosition(params.params)" size="mini">位置</el-button>
      </template>
      <template slot="btn2" slot-scope="params">
        <el-button class="pathbtn" type="primary" @click="showPath(params.params)" size="mini">轨迹</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'car',
      // formInline: {
      //   status: 1,
      // },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          placeholder: "请填写司机姓名",
          type: "text",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: []
        },
        /*{
          label: "核定载重",
          keyName: "ton",
          placeholder: "请填写核定载重",
          type: "number",
        },*/
      ],
      cols: [
        { keyName: "fleetname", label: "车队长", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "trailer", label: "挂车号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "escort", label: "押运员", minwidth: 110 },
        { keyName: "vtype", label: "车辆类型", minwidth: 120 },
        { keyName: "ton", label: "核定载重(吨)", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "buytime", label: "车辆购入时间", minwidth: 130 },
        //{ keyName: "carstatus", label: "车辆状态" },
        { keyName: "money", label: "预支款", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "gettrip", label: "本月行驶里程", minwidth: 120, slot: 'gettrip' },
        { keyName: "", label: "位置", slot: 'btn1' },
        { keyName: "", label: "轨迹", slot: 'btn2' },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id, fleet, fleetname }) => {
            // this.setUserViewHistory(id)
            this.$router.push(
              `/vehicle/view?mode=view&id=${id}&fleetid=${fleet}&fleetName=${fleetname}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id, fleet, fleetname }) => {
            this.$router.push(`/vehicle/detail?mode=edit&id=${id}&fleetid=${fleet}&fleetName=${fleetname}`);
          },
        },
        {
          class: 'documentbtn',
          img: require('@/assets/img/icon_document.png'),
          unimg: require('@/assets/img/icon_document_hover.png'),
          title: '证件',
          cb: ({ id, license }) => {
            this.$router.push(`/vehicle/document?car_type=1&carid=${id}&license=${license}`);
          },
        },
        {
          class: 'insurancebtn',
          img: require('@/assets/img/icon_insurance.png'),
          unimg: require('@/assets/img/icon_insurance_hover.png'),
          title: '保险',
          cb: ({ id, license }) => {
            this.$router.push(`/vehicle/insurance?car_type=1&carid=${id}&license=${license}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      baseParams: ['carstatus'],
      list: ['在用', '停用', '报废'],
      team: [],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    showTrip({ license }) {
      this.$router.push(`/vehicle/viewTrip?license=${license}`)
    },
    addItem() {
      this.$router.push(`/vehicle/detail`);
    },
    setParams() {
      const status = this.$route.path[this.$route.path.length - 1]
      this.formInline.carstatus = this.list[status - 1];
      // 切换状态重置页码
      this.page = 1
      this.getList()
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (['fleet', 'vtype'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    getOptions() {
      this.post(`${this.baseUrl}/index`, {}, ({ team, cartype }) => {
        this.team = team
        this.setParams()
        this.formCtrl.map(v => {
          if (v.keyName == 'vtype') {
            this.setCtrlOption(v, cartype, 'name', 'name')
          } else if (v.keyName === 'fleet') {
            this.setCtrlOption(v, team, 'nickname')
          }
        })
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    showPosition({ license, is_gps }) {
      if (is_gps != 1) {
        this.$message({
          type: 'error',
          message: '未绑定定位设备!'
        });
        return;
      }
      this.$router.push(`/vehicle/position?license=${license}`)
      // this.post(`${this.baseUrl}/location`, { license }, ({ msg, url }) => {
      //   if (msg === 'success' && url) {
      //     // location.href = url
      //     this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${license + '现在位置'}`)
      //   }
      // }, err => {
      //   console.log(err)
      //   this.$message({
      //     type: 'error',
      //     message: '获取数据失败，请稍后重试！'
      //   });
      // })
    },
    showPath({ license, is_gps }) {
      if (is_gps != 1) {
        this.$message({
          type: 'error',
          message: '未绑定定位设备!'
        });
        return;
      }
      console.log(license)
      this.post(`${this.baseUrl}/history`, { license }, ({ msg, url }) => {
        if (msg === 'success' && url) {
          // location.href = url
          // this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${license + '历史轨迹'}`)
          this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${license}`)
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams()
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getOptions();
    const { user_group_id } = this.user
    if (![1, 5, 6, 7].includes(user_group_id)) {
      this.btns.length = 1
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form--inline .el-form-item:nth-last-child(3) {
  margin-right: 20px;
}

.lcbtn {
  color: #409EFF;
  cursor: pointer;
}
</style>